<app-dt-card class="dmdl-container">
  <!-- Encabezado con el filtro de período, que vale para las dos secciones -->
  <div class="dmdl-header">
    <h3 class="dt-titulo dmdl-titulo">
      <mat-icon>analytics</mat-icon>
      Métricas de downlinks
      @if (cargando) {
        <mat-spinner diameter="16"></mat-spinner>
      }
    </h3>
    <app-date-picker
      mode="daterange"
      label="Período"
      [maxDate]="hoy"
      [(ngModel)]="rango"
      (ngModelChange)="onRangoChange($event)"
    ></app-date-picker>
  </div>

  @if (sinDatos && !cargando) {
    <div class="dmdl-vacio">
      <mat-icon>inbox</mat-icon>
      Sin métricas de downlinks para esta luminaria en el período.
    </div>
  } @else {
    <section class="dmdl-seccion">
      <div class="dmdl-seccion-head">
        <h4>Confirmación de la luminaria</h4>
        <app-metrica-help
          intro="Cómo se confirman los downlinks de esta luminaria: ACK del dispositivo en los SET y uplinks de configuración en los auto-GET."
          [items]="helpConfirmacion"
        />
      </div>

      <app-dt-datos destacado>
        <app-dt-dato etiqueta="ACK true" [valor]="totAckTrue | number" />
        <app-dt-dato etiqueta="ACK false" [valor]="totAckFalse | number" />
        <app-dt-dato
          etiqueta="Confirmado por uplink"
          [valor]="totUplink | number"
        />
        <app-dt-dato etiqueta="Forzados" [valor]="totForzados | number" />
      </app-dt-datos>

      @if (hayFranjas) {
        <div class="metricas-chart chart-pair">
          <div class="chart-cell">
            <h5>ACK false por franja</h5>
            <app-graficos
              [pantallaCompleta]="true"
              tipo="column"
              [series]="serieAckFalse"
              [categorias]="categorias"
              [colorPaleta]="paletaBarras"
              tituloEjeY="ACK false"
              [mostrarLeyenda]="false"
              altura="260px"
            ></app-graficos>
          </div>
          <div class="chart-cell">
            <h5>Confirmación por franja</h5>
            <app-graficos
              [pantallaCompleta]="true"
              tipo="line"
              [series]="serieConfirmacion"
              [categorias]="categorias"
              tituloEjeY="Cantidad"
              altura="260px"
            ></app-graficos>
          </div>
        </div>
      }
    </section>

    <section class="dmdl-seccion">
      <div class="dmdl-seccion-head">
        <h4>Fallas por puerto (aspecto de configuración)</h4>
        <app-metrica-help
          intro="Desglose por puerto LoRaWAN (aspecto de config) de las fallas de bajada de esta luminaria, agregado en el período."
          [items]="helpPuertos"
        />
      </div>
      @if (hayPuertos) {
        <div class="metricas-chart">
          <h5>Agregado del período por puerto</h5>
          <app-graficos
            [pantallaCompleta]="true"
            tipo="column"
            [series]="seriePuertos"
            [categorias]="catPuertos"
            tituloEjeX="Puerto"
            tituloEjeY="Cantidad"
            altura="280px"
          ></app-graficos>
        </div>
      } @else {
        <span class="dmdl-muted">Sin fallas por puerto en el período.</span>
      }
    </section>
  }
</app-dt-card>
